const scale = (px, printerWidth) => `calc(calc(${px} / var(--pixel-ratio)) * ${printerWidth === 80 ? 1.3 : 1})`

export default scale